import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomePageService} from './homepage.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {

  queryData: any = {};
  querySubmitted = false;
  queryResponseMessage = '';

  bookAppointmentData: any = {};
  newAppointmentData: any = {};

  firstPage = false;
  secondPage = false;
  thirdPage = false;

  contentTitle: string = '';
  contentPoint1: string = '';
  contentPoint2: string = '';
  contentPoint3: string = '';
  tagHeading: string = '';
  tagLine: string = '';

  subjectsList: any[] = [];
  servicesList: any[] = [];
  queryFileData: FormData = new FormData();
  fileUploadError:string='';
  fileAdded:boolean = false;
  emptyFieldError = false;
  emptyQueryFieldError = false;
  currentYear: number;

  constructor(
    private homePageService: HomePageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.firstPage = true;
    this.secondPage = false;
    this.thirdPage = false;

    this.querySubmitted = false;
    this.emptyQueryFieldError = false;

    this.getHomepageContent();
    this.listAllSubjects();
    this.listAllServices();

    this.currentYear = new Date().getFullYear();
  }

  // onPayNowClick() {
  //   if (
  //       this.bookAppointmentData.name !== '' &&
  //       this.bookAppointmentData.email !== '' &&
  //       this.bookAppointmentData.service != null
  //     ) {
  //     this.secondPage = true;
  //     this.firstPage = false;
  //     this.thirdPage = false;
  //   } else {
  //     this.emptyFieldError = true;
  //   }
  // }

  onBack() {
    this.secondPage = false;
    this.firstPage = true;
    this.thirdPage = false;
  }

  onBookAppointment() {
    this.bookAppointmentData = {};
    this.onBack();
  }

  onSubmit() {
    this.emptyQueryFieldError = false;
    if (
        this.queryData.email != null &&
        this.queryData.fullName != null &&
        this.queryData.mobileNumber != null &&
        this.queryData.subject != null &&
        this.queryData.message != null
      ) {
      this.querySubmitted = true;
      this.queryFileData.append('fullName', this.queryData.fullName);
      this.queryFileData.append('mobileNumber', this.queryData.mobileNumber);
      this.queryFileData.append('email', this.queryData.email);
      this.queryFileData.append('subject', this.queryData.subject);
      this.queryFileData.append('message', this.queryData.message);

      this.homePageService.queryForm(this.queryFileData).subscribe((data:any) => {
        if (data.success === true) {
          this.querySubmitted = true;
          this.queryResponseMessage = data.result;
        } else {
          this.querySubmitted = true;
          this.queryResponseMessage = data.result;
        }
      });
      this.clearQueryData();
    } else {
      this.emptyQueryFieldError = true;
    }

  }

  getHomepageContent() {
    this.homePageService.homepageContent().subscribe((data:any) => {
      this.contentTitle = data.homePageList[0].title1;
      this.contentPoint1 = data.homePageList[0].point1[0];
      this.contentPoint2 = data.homePageList[0].point1[1];
      this.contentPoint3 = data.homePageList[0].point1[2];
      this.tagHeading = data.homePageList[0].title2;
      this.tagLine = data.homePageList[0].point2;
    });
  }

  listAllSubjects() {
    this.homePageService.subjectsList().subscribe((data: any) => {
      this.subjectsList = data.subjectList;
    });
  }

  listAllServices() {
    this.homePageService.servicesList().subscribe((data: any) => {
      this.servicesList = data.serviceList;
    });
  }

  onUploadFile(event:any) {
    // console.log("DDDDDDDDDDD",event);
    let selectedFile = <File>event.target.files[0];
    this.fileAdded = true;
    if (selectedFile != null) {
      if(selectedFile.size>94913969){
        this.fileUploadError="*File size should less than 5 mb!";
      }
      else {
        this.queryFileData.append('attachedFile', selectedFile, selectedFile.name);
      }
    }
  }

  clearQueryData() {
    this.fileAdded = false;
    this.queryFileData.delete('fullName');
    this.queryFileData.delete('mobileNumber');
    this.queryFileData.delete('email');
    this.queryFileData.delete('subject');
    this.queryFileData.delete('message');
    this.queryFileData.delete('attachedFile');

    this.queryFileData = new FormData();
    this.queryData= {};
  }

  getPaymentData(newAppointment: any) {
    this.firstPage = false;
    this.secondPage = false;
    this.thirdPage = true;

    this.newAppointmentData = newAppointment;
    const currentDate = new Date();
    this.newAppointmentData.currentDate = currentDate;
    for(let service of this.servicesList) {
      if (service._id === this.newAppointmentData.service) {
        this.newAppointmentData.serviceName = service.title;
      }
    }
  }


}

